import { MenuItem } from '@mui/material';
import PropTypes from 'prop-types';

import SelectField from 'common/forms/SelectField';
import { TagMatchMode } from 'enums/common.enum';

// POM-6330: the Exact / Contains choice for a queue's Tags filter. See utils/tagMatchMode.
const TagMatchModeField = ({ id, disabled }) => (
  <SelectField label='Tag Match' name='tagMatchMode' id={id} disabled={disabled}>
    <MenuItem value={TagMatchMode.EXACT}>Exact match</MenuItem>
    <MenuItem value={TagMatchMode.CONTAINS_ALL}>Contains all selected tags</MenuItem>
  </SelectField>
);

TagMatchModeField.propTypes = {
  id: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};

TagMatchModeField.defaultProps = {
  disabled: false,
};

export default TagMatchModeField;
